
import Vue from 'vue';
import {ColorTileLoader} from '../loaders/ColorTileLoader'

export default Vue.extend({
  name: 'ColorPickerComponent',
  props: ['colors', 'componentName', "header", "material"],
  data() {
    return {};
  },
  methods: {
    hover(color: string) {
      this.$emit('hover', {color, material: this.material})
    },
    selectedColor(color: string) {
      this.$emit('colorChange', {color, material: this.material});
    },
    getSrc(color: string) {
        return ColorTileLoader.loadColorTile(this.componentName, color, this.material)
    },
    getTranslatedColor(color: string) {
      return this.$t(`colors.${color}`).toString()
    }
  },
});
